import { defineComponent as _defineComponent } from 'vue'
import {
    GalleryMicrotrend,
    GalleryMicrotrendAuthor,
    MicrotrendGalleryCardTextContent
} from '@/ui/microtrend/microtrend-gallery-card/microtrend-gallery-card.types'
// @ts-ignore
import ellipsize from 'ellipsize'
import { computed } from 'vue'
import ToIcon from '@/components/to-icon/to-icon.vue'
import AuthorInfo from '@/ui/author-info/author-info.vue'

interface Props {
  microtrend: GalleryMicrotrend
  noTranslation?: boolean
  isNew?: boolean
  hasUseCases?: boolean
  companyTrend?: boolean
  reducedTrend?: boolean
  author?: GalleryMicrotrendAuthor,
  textContent: MicrotrendGalleryCardTextContent
}


export default /*#__PURE__*/_defineComponent({
  __name: 'microtrend-gallery-card',
  props: {
    microtrend: null,
    noTranslation: { type: Boolean, default: false },
    isNew: { type: Boolean, default: false },
    hasUseCases: { type: Boolean, default: false },
    companyTrend: { type: Boolean },
    reducedTrend: { type: Boolean },
    author: null,
    textContent: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as { microtrend: GalleryMicrotrend, noTranslation: boolean, isNew: boolean, hasUseCases: boolean, companyTrend?: boolean, reducedTrend?: boolean, author?: GalleryMicrotrendAuthor, textContent: MicrotrendGalleryCardTextContent }





const truncatedDescription = computed(() => {
    return ellipsize(props.microtrend.description, 150, { chars: [' ', '&', ',', '.'], ellipse: '...' })
})

const onClick = (event: PointerEvent) => emit('click', event)

const cardClass = computed(() => {
    const standard = 'microtrend microtrend-gallery-card'

    if (props.reducedTrend) {
        return standard + ' no-action'
    }

    return standard
})

return { __sfc: true,props, emit, truncatedDescription, onClick, cardClass, ToIcon, AuthorInfo }
}

})